// extracted by mini-css-extract-plugin
export default {"root":"radio_root__4107Z","active":"radio_active__aL1wJ","circle":"radio_circle__LPSKq"};